import { styled } from '@mui/material/styles';
import { RaisinContainer, Typography } from '@raisin/components-lib';

export const HeroWrapper = styled('div')({
  height: 480,
  background: 'linear-gradient(87.52deg, #002B51 23.41%, #267EBC 97.56%)',
});

export const FlexContainer = styled(RaisinContainer)({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});

export const ContentWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    maxWidth: 840,
  },
}));

export const Heading = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(6),
}));
